import './locations_reservations';
import './locations_reservations-list';
import './locations_reservations-edit';
import './locations_reservations-timeline';
import './locations/locations';
import './locations/locations-list';
import './locations/locations-edit'; 